export const PAGE_ROUTES = [
  { id: 'home', de: '/', en: '/en' },
  { id: 'about', de: '/ueber-mich', en: '/en/about' },
  { id: 'services', de: '/leistungen', en: '/en/services' },
  { id: 'insights', de: '/impulse', en: '/en/insights' },
  { id: 'testimonials', de: '/stimmen', en: '/en/testimonials' },
  { id: 'contact', de: '/kontakt', en: '/en/contact' },
  { id: 'speaking', de: '/vortraege', en: '/en/speaking' },
  { id: 'legal', de: '/impressum', en: '/en/legal-notice' },
  { id: 'privacy', de: '/datenschutz', en: '/en/privacy' },
];

export function normalizePath(pathname) {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/$/, '') || '/';
}

export function isEnglishPath(pathname) {
  const path = normalizePath(pathname);
  return path === '/en' || path.startsWith('/en/');
}

export function pageFromPath(pathname) {
  const path = normalizePath(pathname);
  return PAGE_ROUTES.find((route) => route.de === path || route.en === path) || null;
}

export function pathForLang(pathname, hash, lang) {
  const page = pageFromPath(pathname);
  const base = page ? page[lang] : (lang === 'en' ? '/en' : '/');
  const path = normalizePath(pathname);
  if ((path === '/' || path === '/en') && hash) {
    return `${base}${hash}`;
  }
  return base;
}

export function homePath(lang) {
  return lang === 'en' ? '/en' : '/';
}
